import { useCallback } from 'react'
import type { PropsWithChildren } from 'react'
import { useIsPC } from '~/lib/ua'
import { useSendClickEvent } from '~/navigation'
import { css, sva } from '~/styled-system/css'
import { useDisplayPointAndCouponType } from '../../store/discountCoupon'
import type { DisplayPointAndCouponType } from '../../store/discountCoupon'
import { useLoginProps } from '../../store/reserve'
import { useTransitionPreMemberChecked } from '../../store/userInput'
import { Section } from '../Section'

export function PointAndDiscountCouponUnavailable(props: {
  onRegistrationLinkClicked: () => void
}) {
  const isPC = useIsPC()
  const Container = isPC ? PcContainer : Section
  const display = useDisplayPointAndCouponType()
  if (display === undefined) {
    return null
  }
  return (
    <Container title={title(display)}>
      <Body display={display} {...props} />
    </Container>
  )
}

const pcStyle = sva({
  slots: ['container', 'head', 'title'],
  base: {
    container: {
      bg: 'white',
      p: '6',
      spaceY: '2',
    },
    title: {
      fontSize: '2xl',
      fontWeight: 'bold',
    },
  },
})

function PcContainer(props: PropsWithChildren<{ title: string }>) {
  const classes = pcStyle()
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{props.title}</h2>
      {props.children}
    </div>
  )
}

function title(display: DisplayPointAndCouponType) {
  switch (display) {
    case 'pointUnavailable':
    case 'seatOnly':
      return '割引クーポン・ポイント利用'
    case 'popupCouponDisplayed':
      return '割引クーポン利用'
  }
}

function Body(props: {
  display: DisplayPointAndCouponType
  onRegistrationLinkClicked: () => void
}) {
  const { onOpen: openLoginModal } = useLoginProps()

  const change = useTransitionPreMemberChecked()
  const sendClickEvent = useSendClickEvent()
  const onRegistrationLinkClicked = useCallback(() => {
    //sendClickEvent({ member: 'onClick', click_event: 'ReserveInput/member/onClick' })
    change(true)
    props.onRegistrationLinkClicked()
  }, [change, sendClickEvent, props.onRegistrationLinkClicked])

  switch (props.display) {
    case 'pointUnavailable':
      return (
        <p className={css({ fontSize: 'sm', color: 'error.text' })}>
          この店舗で割引クーポン・ポイントはご利用いただけません。
        </p>
      )
    case 'seatOnly':
      return (
        <p className={css({ fontSize: 'sm', color: 'error.text' })}>
          お席のみのご予約の場合、割引クーポン・ポイントはご利用いただけません。
        </p>
      )
    case 'popupCouponDisplayed':
      return (
        <p className={css({ bgColor: 'gray.100', p: '3', rounded: 'sm' })}>
          クーポンをご利用いただくには
          <button type="button" onClick={openLoginModal(false)} className={css({ color: 'link' })}>
            ログイン
          </button>
          または
          <button
            type="button"
            onClick={onRegistrationLinkClicked}
            className={css({ color: 'link' })}
          >
            会員登録
          </button>
          が必要です。
        </p>
      )
  }
}
